import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, ArrowUpRight, Clock } from 'lucide-react';
import BrandMark from '../brand/BrandMark';
import { SITE } from '../../lib/site';

export default function SiteFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="relative mt-24 border-t border-white/10 bg-[rgba(8,11,18,0.85)]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <Link to="/" className="inline-flex items-center gap-2">
                        <BrandMark className="h-7 w-7" />
                        <span className="font-display text-lg font-semibold">DigiTech <span className="text-primary">Cloud AI</span></span>
                    </Link>
                    <p className="mt-4 text-sm text-muted-foreground max-w-md leading-relaxed">
                        An advanced technology and software-engineering partner delivering secure, intelligent, and scalable digital systems for governments, enterprises, and ambitious ventures.
                    </p>
                    <p className="mt-3 text-xs font-mono uppercase tracking-widest text-muted-foreground">
                        United Kingdom subsidiary · Metatron Technologies Ltd
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground mb-4">EXPLORE</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/" className="text-foreground/80 hover:text-primary">Home</Link></li>
                        <li><Link to="/services" className="text-foreground/80 hover:text-primary">Services</Link></li>
                        <li><Link to="/mission" className="text-foreground/80 hover:text-primary">Mission & Vision</Link></li>
                        <li><Link to="/blog" className="text-foreground/80 hover:text-primary">Blog</Link></li>
                        <li><Link to="/contact" className="text-foreground/80 hover:text-primary">Contact</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground mb-4">CONTACT</div>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-2 text-foreground/80">
                            <Mail className="h-4 w-4 mt-0.5 text-primary" />
                            <a href={`mailto:${SITE.email}`} className="hover:text-primary">{SITE.email}</a>
                        </li>
                        <li className="flex items-start gap-2 text-foreground/80">
                            <Phone className="h-4 w-4 mt-0.5 text-primary" />
                            <a href={`tel:${SITE.phone.replace(/[^+\d]/g, '')}`} className="hover:text-primary">{SITE.phone}</a>
                        </li>
                        <li className="flex items-start gap-2 text-foreground/80">
                            <MapPin className="h-4 w-4 mt-0.5 text-primary" />
                            <span>{SITE.address}</span>
                        </li>
                        <li className="flex items-start gap-2 text-foreground/80">
                            <Clock className="h-4 w-4 mt-0.5 text-primary" />
                            <span>{SITE.hours}</span>
                        </li>
                    </ul>
                    <Link
                        to="/contact"
                        className="mt-6 inline-flex items-center gap-1.5 text-sm text-primary hover:text-accent"
                    >
                        Start a Conversation <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-muted-foreground">
                    <span>© {new Date().getFullYear()} DigiTech Cloud AI. All rights reserved.</span>
                    <span className="font-mono tracking-wider text-muted-foreground/70">UK Subsidiary · Metatron Technologies Ltd</span>
                </div>
            </div>
        </footer>
    );
}
